import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/pages/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "PÓS FASIPE",
    component: Home,
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
